import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
// import privacy from '../views/privacy.vue'
// import child from '../views/child.vue'
// import Application from '../views/Application.vue'
// import ASDKS from '../views/ASDKS.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import(/* webpackChunkName: "about" */ '../views/privacy.vue')
  },
  {
    path: '/child',
    name: 'child',
    component: () => import(/* webpackChunkName: "about" */ '../views/child.vue')
  },
  {
    path: '/Application',
    name: 'Application',
    component: () => import(/* webpackChunkName: "about" */ '../views/Application.vue')
  },
  {
    path: '/ASDKS',
    name: 'ASDKS',
    component: () => import(/* webpackChunkName: "about" */ '../views/ASDKS.vue')
  },,
  {
    path: '/shareSdk',
    name: '第三方信息共享清单',
    component: () => import(/* webpackChunkName: "about" */ '../views/shareSdk.vue')
  },
  {
    path: '/information',
    name: '个人信息收集清单',
    component: () => import(/* webpackChunkName: "about" */ '../views/information.vue')
  }
]

const router = new VueRouter({
  // mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0}
  },
  base: process.env.BASE_URL,
  routes
})

export default router
